/* eslint-disable jira/filename-case */

// eslint-disable-next-line no-restricted-imports, jira/restricted/@atlaskit+modal-dialog
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import type { ModalDialogProps } from '@atlaskit/modal-dialog/types';
import type { ChoreographedComponentProps } from '@jira/platform__choreographer-services/src/types.tsx';
import { withChoreographedRender } from '@jira/platform__choreographer-services/src/withChoreographedRender.tsx';

export const ChoreographerModal: {
	(props: ModalDialogProps & ChoreographedComponentProps): React.JSX.Element;
	displayName: string;
} = withChoreographedRender<ModalDialogProps>(Modal);
